import React from "react";
import { graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Layout from "../components/layout"
import Seo from "../components/seo"

const title = "Virtual Market 4 \"DEFAULT CUBE\""
const scope = "VR空間体験設計・制作"
const str1 = "「バーチャルマーケット4」の会場「デフォルトキューブ」の空間体験ディレクション、制作チームの一員として制作を行った。"
const str2 = "キューブに棲む「UIちゃん」とのインタラクションを通して、出展者＝クリエイターの創作が目の前で生まれ、ひとつの作品と向き合う空間へと変化する、会場空間のない展示会場。"

const settings = {
  arrows: false,
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 5000,
  pauseOnHover: false,
}

export default ({ data, location }) => (
      <Layout>
        <Seo
          pagetitle={title}
          pagedesc={str1}
          pagepath={location.pathname}
          pageimg={data.dc01.childImageSharp.original.src}
          pageimgw={data.dc01.childImageSharp.original.width}
          pageimgh={data.dc01.childImageSharp.original.height}
        />
        <div className="nav">
          <Link to = {`/works/`}>
            <svg className="switchButton" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.41 52.83">
            <g id="_レイヤー_2" data-name="レイヤー_2">
              <g id="UI">
                <path d="M1.4,2.2l47.3,24.2L1.4,50.7l.4.9,47.9-24.6,47.9,24.6.5-.9-47.3-24.3L98,2.1l-.5-.9-47.8,24.6L1.8,1.2l-.4.9Z"/>
              </g>
            </g>
            </svg>
          </Link>
        </div>
        <div id="pageBody" className="wrapper">
          <Slider {...settings}>
            <div className="full">
              <StaticImage className="cover" src="../images/dc01.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/dc02.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/dc03.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/dc04.jpg" alt="" />
            </div>
          </Slider>
          <div className="title">
            <h4>{title}</h4>
            <p><span>{scope}</span></p>
            <br />
            <p>{str1}</p>
            <p>{str2}</p>
          </div>
        </div>
      </Layout>
)

export const query = graphql`
query {
  dc01: file(relativePath: {eq: "dc01.jpg"}) {
    childImageSharp {
      original {
        height
        src
        width
      }
    }
  }
}
`
